const input = document.getElementById("newsletterInput");
const errorMsg = document.querySelector(".newsletter__message--error");
const successMsg = document.querySelector(".newsletter__message--success");
const submitBtn = document.querySelector(".newsletter__submit");
let flag = true;
const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

// Prevent space as input
input.addEventListener("keypress", (e) => {
  if (e.code === "Space") {
    e.preventDefault();
  }
});

// Validate email
input.addEventListener("input", (e) => {
  successMsg.style.display = "hidden";
  if (e.target.value != "" && !validateEmail(e.target.value)) {
    errorMsg.style.display = "block";
    flag = false;
  } else {
    errorMsg.style.display = "none";
    flag = true;
  }
});

function validateEmail(email) {
  return regex.test(email);
}

submitBtn.onclick = () => {
  if (flag) {
    // Make the POST request to add the user to the list
    axios.post("https://staging.api.dot.cards/klaviyo/subscribe/Siierg", {
      email: input.value,
    });
    successMsg.style.display = "block";
    input.value = "";
    flag = false;
  }
};
